import { ButtonLink } from '../ui/ButtonLink';
import { Reveal } from '../ui/Reveal';

export function FreePreviewSection() {
  return (
    <section className="section free-preview-section">
      <div className="shell free-preview-section__panel">
        <Reveal><div>
          <p className="eyebrow">Optional Free Preview</p>
          <h2>Want to see a direction before committing?</h2>
          <p>Free previews are available for suitable new website and redesign projects.</p>
        </div></Reveal>
        <Reveal className="free-preview-section__cta" delay={0.08}><ButtonLink href="/contact?preview=1">Request a Preview</ButtonLink></Reveal>
      </div>
    </section>
  );
}
